import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertWarning20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.0721 2.32868C10.5865 1.51951 9.41382 1.51951 8.92832 2.32868L0.811412 15.8569C0.311518 16.69 0.911662 17.75 1.88328 17.75H7.00018V16.25H2.32483L10.0002 3.45771L17.6755 16.25H13.0002V17.75H18.1171C19.0887 17.75 19.6888 16.69 19.189 15.8569L11.0721 2.32868Z'
      fill='currentColor'
    />
    <path d='M10.75 8V14H9.25V8H10.75Z' fill='currentColor' />
    <path
      d='M10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16C9.44771 16 9 16.4477 9 17C9 17.5523 9.44771 18 10 18Z'
      fill='currentColor'
    />
  </Svg>
);

AlertWarning20.displayName = 'AlertWarning20';
export default AlertWarning20;
